import uniq from 'lodash/uniq';

import { ALL_TRYBES_MEN } from './TrybesMenList.constants';

export const getUniqueTrybesMenCategories = trybesList => {
  return [ALL_TRYBES_MEN, ...uniq(trybesList.map(x => x.team))];
};
